import React from 'react';
import { Create } from 'react-admin';
import SubtemaForm from '../SubtemaForm';

function SubtemaCreate(props) {
  return (
    <Create {...props}>
      <SubtemaForm redirect="list" />
    </Create>
  );
}

export default SubtemaCreate;
